// extracted by mini-css-extract-plugin
module.exports = {"container":"navYmm_container__vWO1m","selection":"navYmm_selection__7pkMS","ymmTextWrapper":"navYmm_ymmTextWrapper__UBRPg","containerWrapper":"navYmm_containerWrapper__Sq8p0"};